import React from "react";
import { Grid } from "@mui/material";

import { formatNumberNull, formatUpperCase } from "../../../../utils/formats";
import Table from "../../subcomponents/Table";
import {
  each,
  find,
  first,
  get,
  groupBy,
  map,
  maxBy,
  minBy,
  set,
  size,
} from "lodash";
import { formatDate, parseDate } from "../../../../utils/dateFns";
import { add, getMonth, getYear } from "date-fns";

const columns = [
  {
    id: "grupo",
    name: "Grupo",
    render: formatUpperCase,
  },
  {
    id: "modalidade",
    name: "Modalidade",
    render: formatUpperCase,
  },
];

const style = {
  justify: "center",
  width: 50,
};

const monthLabels = {
  1: "Jan",
  2: "Fev",
  3: "Mar",
  4: "Abr",
  5: "Mai",
  6: "Jun",
  7: "Jul",
  8: "Ago",
  9: "Set",
  10: "Out",
  11: "Nov",
  12: "Dez",
};

const orderColumns = (proposalFluxoModalidade) => {
  const sortedColuns = proposalFluxoModalidade.sort((itemFirst, itemSecond) => {
    let first = itemFirst.grupo.toUpperCase();
    let second = itemSecond.grupo.toUpperCase();
    if ("LIMITE" === first) {
      return 1;
    } else if ("LIMITE" === second) {
      return -1;
    } else if (first < second) {
      return -1;
    } else if (second > first) {
      return 1;
    }

    return 0;
  });

  return sortedColuns;
};

const FluxoModalidadeSection = (props) => {
  const { proposalFluxoModalidadeLoading, proposalFluxoModalidade } = props;
  const monthlyColumns = [];

  const defineMonthlyColumns = (startDate, endDate) => {
    for (
      let date = endDate;
      date >= startDate;
      date = add(date, { months: -1 })
    ) {
      monthlyColumns.push({
        id: formatDate(date, "yyyyMM"),
        name: `${get(monthLabels, getMonth(date) + 1)}/${getYear(date)}`,
        render: formatNumberNull,
        style,
      });
    }
  };

  const handleData = (data) => {
    if (size(data) === 0) return [];

    const yearMonthStart = minBy(data, (it) => it.anoMes).anoMes;
    const startDate = parseDate(`${yearMonthStart}01`, "yyyyMMdd", new Date());
    const yearMonthEnd = maxBy(data, (it) => it.anoMes).anoMes;
    const endDate = parseDate(`${yearMonthEnd}01`, "yyyyMMdd", new Date());

    defineMonthlyColumns(startDate, endDate);

    const byGrupoModalidade = groupBy(
      data,
      (it) => `${it.grupo}-${it.modalidade}`
    );

    return map(byGrupoModalidade, (meses) => {
      const modalidade = first(meses);
      const entry = {
        grupo: modalidade.grupo,
        modalidade: modalidade.modalidade,
      };
      each(meses, (mes) => {
        set(entry, mes.anoMes, mes.valor);
      });
      return entry;
    });
  };

  const handledData = handleData(proposalFluxoModalidade);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={8} md={6}>
          <Table
            loadingRows={2}
            noDataMessage="Sem dados."
            columns={columns}
            loading={proposalFluxoModalidadeLoading}
            entries={orderColumns(handledData)}
          />
        </Grid>
        <Grid item xs={4} md={6}>
          <Table
            loadingRows={2}
            noDataMessage=""
            columns={monthlyColumns}
            loading={proposalFluxoModalidadeLoading}
            entries={handledData}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FluxoModalidadeSection;
